import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGetAllProductsList } from "../../../hooks/product/useGetAllProductsList";


type ProductsFilterProps = {
  onChange: (value: string) => void;
  value?: string;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
export const ProductsFilter: React.FC<ProductsFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  const allProductsForDownloads = useGetAllProductsList("downloads", "name.asc", 999);

  const productsOptions = allProductsForDownloads?.data?.map(
    (product) => ({
      value: product.code,
      label: product.name,
    })
  );

  return (
    <SelectBoxWrapper>
      <Select
        // mode="multiple"
        allowClear
        placeholder={t("licenses.basic.search.product.title")}
        style={{ width: "100%", minWidth: 150 }}
        maxTagCount={1}
        options={productsOptions}
        onChange={onChange}
        value={value}
      />
    </SelectBoxWrapper>
  );
};